class Permissions {

	constructor() {
		this._activeConnection = null;
		this._value = null;
		
		this._groups = [];
		let g = new PermissionGroup(this, 1, _("Timeline"));
		g.add(PERMISSION.TIMELINE_LAYER_ADD_REMOVE, _("Add or remove existing layers"));
		g.add(PERMISSION.TIMELINE_LAYER_EDIT, _("Create new layers"));
		g.add(PERMISSION.TIMELINE_SHARE_LAYER, _("Share timeline layers"));
		g.add(PERMISSION.TIMELINE_EVENT_EDIT, _("Create new events and activities."));
		this._groups.push(g);
		g = new PermissionGroup(this, 2, _("Resources"));
		g.add(PERMISSION.RESOURCE_VIEW, _("View resources page"));
		g.add(PERMISSION.RESOURCE_SYNC, _("Set resources to synchronize with mobile"));
		g.add(PERMISSION.RESOURCE_EDIT, _("Create or edit resources"));
		g.add(PERMISSION.RESOURCE_SHARE, _("Share resources"));
		g.add(PERMISSION.RESOURCE_SEARCH, _("Search library"));
		this._groups.push(g);
		g = new PermissionGroup(this, 3, _("Graphics"));
		g.add(PERMISSION.GRAPHICS_VIEW, _("View graphics page"));
		g.add(PERMISSION.GRAPHIC_ADD_REMOVE, _("Add or remove user graphics"));
		g.add(PERMISSION.GRAPHICS_SHARE, _("Share user graphics"));
		this._groups.push(g);
		g = new PermissionGroup(this, 4, _("Goals"));
		g.add(PERMISSION.CHART_VIEW, _("View goals page"));
		g.add(PERMISSION.CHART_CREATE, _("Make new charts"));
		g.add(PERMISSION.CHART_EDIT, _("Edit / Delete charts"));
		g.add(PERMISSION.CHART_ADD_POINTS, _("Add points to charts"));
		g.add(PERMISSION.CHART_SWAP, _("Swap completed charts"));
		this._groups.push(g);
		g = new PermissionGroup(this, 5, _("Connections"));
		g.add(PERMISSION.CONNECTION_VIEW, _("View connections page"));
		g.add(PERMISSION.CONNECTION_REQUEST, _("Request new connections"));
		g.add(PERMISSION.CONNECTION_ACCEPT, _("Accept connection requests"));
		g.add(PERMISSION.CONNECTION_SET_PERMS, _("Change PERMISSIONs for connections"));
		this._groups.push(g);
		g = new PermissionGroup(this, 6, _("Communities"));
		g.add(PERMISSION.COMMUNITIES_VIEW, _("View communities page"));
		g.add(PERMISSION.COMMUNITIES_JOIN, _("Search for and join existing communities"));
		g.add(PERMISSION.COMMUNITIES_CREATE, _("Create new communities"));
		g.add(PERMISSION.COMMUNITIES_CONTRIBUTE, _("Contribute to community resources"));
		this._groups.push(g);
		g = new PermissionGroup(this, 7, _("Account"));
		g.add(PERMISSION.ACCOUNT_VIEW, _("View account page"));
		g.add(PERMISSION.ACCOUNT_CHANGE_DETAILS, _("Change personal details"));
		g.add(PERMISSION.ACCOUNT_CHANGE_PASS, _("Change password"));
		g.add(PERMISSION.ACCOUNT_OTHER_PREFS, _("Change other preferences"));
		g.add(PERMISSION.ACCOUNT_SUBSCRIPTION, _("Change subscription"));
		this._groups.push(g);
		
		this._dialog = Dialog.Modal('permission', _('Permissions'), X_LARGE, _("SAVE PERMISSIONS"), [
			div('accordion accordion-flush', 
			this._groups.map(g => g.elem()), null, {
				'id': 'permissions-accordion'
			})
		]);
	}

	open(connection) {
		this._activeConnection = connection;
		ajg('supervision/permissions', [
			'userId=' + connection.id
		], null, (reply) => {
			if (showError(reply)) return;
			this._value = reply.permissions;
			this._groups.forEach((g) => g.init(reply.permissions));
			this._dialog.open(this.save.bind(this));
		}, this);
	}

	change (id, add){
		if (add) {
			if ((this._value & id) == 0) {
				this._value += id;
			}
		}
		else {
			if ((this._value & id) != 0) {
				this._value -= id;
			}
		}
	}

	save() {
		ajg('supervision/set-permissions', [
			'userId=' + this._activeConnection.id,
			'value=' + this._value
		], null, (reply) => {
			if (showError(reply)) return;
			makeToast(_("Permissions updated"))
		});
	}
}